<script>
import '$vueCommon/scss/components/_scroll-to-top.scss';

export default {
    components: {},
    mounted() {
        window.addEventListener('scroll', this.CheckScrollPosition);
    },
    unmounted() {
        window.removeEventListener('scroll', this.CheckScrollPosition)
    },
    methods: {
        CheckScrollPosition(e) {
            this.isVisible = window.scrollY > 200;
        },
        ScrollTop() {
            window.scrollTo(0, 0);
        }
    },
    data() {
        return {
            isVisible: false
        }
    }
}
</script>
<template>
    <div class="scroll-to-top p-2" :class="{'is-visible': isVisible}" @click="ScrollTop">
        <i class="fa fa-chevron-up"></i>
    </div>
</template>
